module.exports = [
  {
    date: new Date("2020-01-01 00:00:00"),
    open: 33,
    high: 50.5,
    low: 40.98,
    close: 45.4,
  },
  {
    date: new Date("2020-01-02 00:00:00"),
    open: 50.4,
    high: 55,
    low: 45,
    close: 40.4,
  },
  {
    date: new Date("2020-01-03 00:00:00"),
    open: 45,
    high: 50.5,
    low: 40.98,
    close: 43.4,
  },
  {
    date: new Date("2020-01-04 00:00:00"),
    open: 40,
    high: 45.5,
    low: 43.98,
    close: 42.4,
    volume: 594858493,
  },
  {
    date: new Date("2020-01-05 00:00:00"),
    open: 40.4,
    high: 47,
    low: 43,
    close: 45.4,
    volume: 594858443,
  },
  {
    date: new Date("2020-01-06 00:00:00"),
    open: 43.4,
    high: 44,
    low: 39,
    close: 40.4,
    volume: 594858493,
  },
  {
    date: new Date("2020-01-07 00:00:00"),
    open: 41,
    high: 46.5,
    low: 40.98,
    close: 43.4,
    volume: 594858493,
  },
  {
    date: new Date("2020-01-08 00:00:00"),
    open: 45.4,
    high: 46,
    low: 44,
    close: 43.4,
    volume: 594858443,
  },
  {
    date: new Date("2020-01-09 00:00:00"),
    open: 50.4,
    high: 53,
    low: 45,
    close: 45.4,
    volume: 594858493,
  },
  {
    date: new Date("2020-01-10 00:00:00"),
    open: 45,
    high: 50.5,
    low: 40.98,
    close: 43.4,
    volume: 594858493,
  },
  {
    date: new Date("2020-01-11 00:00:00"),
    open: 50.4,
    high: 60,
    low: 45,
    close: 55.4,
    volume: 594858443,
  },
  {
    date: new Date("2020-01-12 00:00:00"),
    open: 46.4,
    high: 52,
    low: 40,
    close: 43.4,
    volume: 594858493,
  },
  {
    date: new Date("2020-01-13 00:00:00"),
    open: 47,
    high: 56.5,
    low: 40.98,
    close: 46.4,
    volume: 594858493,
  },
  {
    date: new Date("2020-01-14 00:00:00"),
    open: 40.4,
    high: 42,
    low: 31,
    close: 39.4,
    volume: 594858443,
  },
  {
    date: new Date("2020-01-15 00:00:00"),
    open: 45.4,
    high: 49,
    low: 40,
    close: 41,
    volume: 594858493,
  },
  {
    date: new Date("2020-01-16 00:00:00"),
    open: 44,
    high: 50.5,
    low: 41.98,
    close: 46.4,
    volume: 594858493,
  },
  {
    date: new Date("2020-01-17 00:00:00"),
    open: 43.4,
    high: 46,
    low: 39,
    close: 40.4,
    volume: 594858443,
  },
  {
    date: new Date("2020-01-18 00:00:00"),
    open: 44.4,
    high: 55,
    low: 39,
    close: 50.4,
    volume: 594858493,
  },
  {
    date: new Date("2020-01-19 00:00:00"),
    open: 45,
    high: 45,
    low: 40.98,
    close: 49.4,
    volume: 594858493,
  },
  {
    date: new Date("2020-01-20 00:00:00"),
    open: 46.4,
    high: 55,
    low: 40,
    close: 49.4,
    volume: 594858443,
  },
  {
    date: new Date("2020-01-21 00:00:00"),
    open: 49.4,
    high: 56,
    low: 40,
    close: 52.4,
    volume: 594858493,
  },
  {
    date: new Date("2020-01-22 00:00:00"),
    open: 33,
    high: 33.5,
    low: 32.98,
    close: 33.4,
    volume: 594858493,
  },
  {
    date: new Date("2020-01-23 00:00:00"),
    open: 33.4,
    high: 35,
    low: 31,
    close: 32.4,
    volume: 594858443,
  },
  {
    date: new Date("2020-01-24 00:00:00"),
    open: 32.4,
    high: 27,
    low: 28,
    close: 33.4,
    volume: 594858493,
  },
  {
    date: new Date("2021-09-03T13:13:29.249Z"),
    open: 33,
    high: 33.5,
    low: 32.98,
    close: 33.4,
    volume: 594858493,
  },
];
